export default (state = {}, { type, payload }) => {
  switch (type) {
    case 'SET_AUDIENCE_SCOPE': {
      return payload;
    }
    default:
      return state;
  }
};
